var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3346 9.16668V10.8333H6.66797V9.16668H13.3346ZM9.16797 13.3333H6.66797C4.82996 13.3333 3.33465 11.838 3.33465 10C3.33465 8.16199 4.82996 6.66668 6.66797 6.66668H9.16797V5H6.66797C3.90652 5 1.66797 7.23855 1.66797 10C1.66797 12.7614 3.90652 15 6.66797 15H9.16797V13.3333ZM13.3346 5H10.8346V6.66668H13.3346C15.1727 6.66668 16.668 8.16199 16.668 10C16.668 11.838 15.1727 13.3333 13.3346 13.3333H10.8346V15H13.3346C16.0961 15 18.3347 12.7614 18.3347 10C18.3347 7.23855 16.0961 5 13.3346 5Z",
    fill: "#005B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.25577bb8342af1680cbe7f030dea7921.svg";
export { ForwardRef as ReactComponent };